import React from 'react';
import './AXIS.css';
import { Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import logo from '../../Raya logo/TalentAxis (10) (1).png';
import cover from '../../Raya logo/TalentAxis (10) (1).png'
const AXIS = () => {
    const navigate = useNavigate();


    const transferToPage = () => {
        // navigate('/Louco');
        window.open('https://www.2axis.ai/')
    }

    return (
        <div className='main-first-section'>
            <Container maxWidth="xl">
                <div className='content'>
                    <div className='text-container'>
                        <img
                            src={logo}
                            className="logo-img"
                            alt='logo not found'
                        />
                        <h1> Executive Intelligence</h1>
                        <h3>The Science of Exceptional Talent for companies building the future of technology.</h3>
                        <ArrowForwardIcon onClick={transferToPage} style={{ fontSize: '22px', border: '1px solid #000', marginTop: '0px', borderRadius: '50%', padding: '4px', cursor: 'pointer' }} />
                    </div>
                    <div className='louco-header-img'>


                        <img
                            src={cover}
                            className="cover-img"
                            alt="mobile image not found"
                        />
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default AXIS;
